<div class="cohorts-container">
	<div class="header">
		<div class="title">
			<h1>My Surveys</h1>
			<div class="subtitle">View and complete your assigned surveys</div>
		</div>
	</div>

	<div class="cohorts-list">
		<mat-card *ngFor="let cohort of memberCohorts()" class="cohort-card">
			<div class="card-content">
				<div class="card-header">
					<div class="cohort-info">
						<h2 class="org-name">{{ cohort.organization_name }}</h2>
						<p class="survey-name">{{ cohort.cohort_name }}</p>
					</div>
					<mat-chip [color]="getStatusColor(cohort.status)" selected>
						{{ getStatusText(cohort.status) }}
					</mat-chip>
				</div>

				<div class="progress-container">
					<div class="progress-label">
						<span>Progress: {{ cohort.progress }}%</span>
						<span
							>{{ cohort.answered_count }} of
							{{ cohort.question_count }} questions</span
						>
					</div>
					<mat-progress-bar
						[color]="getStatusColor(cohort.status)"
						mode="determinate"
						[value]="cohort.progress"
					></mat-progress-bar>
				</div>

				<div class="card-footer">
					<div class="status-info">
						<div class="status-item">
							<mat-icon>schedule</mat-icon>
							<span>Created: {{ formatDate(cohort.created_at) | date }}</span>
						</div>
						<div class="status-item" *ngIf="cohort.completed_at">
							<mat-icon>done_all</mat-icon>
							<span>Completed: {{ formatDate(cohort.completed_at) | date }}</span>
						</div>
					</div>
				</div>

				<div class="action-button-container">
					<button
						mat-raised-button
						color="primary"
						class="start-button"
						[routerLink]="['/cohorts', cohort.organization_cohort_id, cohort.member_id]"
					>
						<span *ngIf="cohort.progress > 0 && cohort.progress < 100"
							>Continue Survey</span
						>
						<span *ngIf="cohort.progress === 0">Start Survey</span>
						<span *ngIf="cohort.progress === 100">Review Survey</span>
					</button>
				</div>
			</div>
		</mat-card>
	</div>

	<div class="grid-container" *ngIf="memberCohorts().length === 0 && !loading()">
		<div class="no-data">
			<mat-icon>assignment</mat-icon>
			<p>No surveys assigned to you</p>
			<p class="secondary-text">
				Contact your organization administrator if you believe this is an error
			</p>
		</div>
	</div>

	<div class="loading" *ngIf="loading()">
		<mat-spinner diameter="40"></mat-spinner>
	</div>
</div>
